<template>
  <footer>
    <div class="container mt-5">
      <!-- <div class="row justify-content-between ms-lg-5 ps-lg-5">
                <div class="col-12 col-sm-6 col-lg-3 p-5 ps-lg-0">
                    <h3 class="position-relative mb-5 arrow-bottom">خرید و فروش تهران</h3>
                    <ul class="list-unstyled">
                        <li v-for="item in tehranLinks" class="mb-4">
                            <a href="#" class="text-muted">{{ item.title }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-12 col-sm-6 col-lg-3 p-5 ps-lg-0">
                    <h3 class="position-relative mb-5 arrow-bottom">رهن و اجاره تهران</h3>
                    <ul class="list-unstyled">
                        <li v-for="item in tehranLinks" class="mb-4">
                            <a href="#" class="text-muted">{{ item.title }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-3 d-none d-lg-block p-5 ps-lg-0">
                    <h3 class="position-relative mb-5 arrow-bottom">خرید و فروش سایر شهرها</h3>
                    <ul class="list-unstyled">
                        <li v-for="item in tehranLinks" class="mb-4">
                            <a href="#" class="text-muted">{{ item.title }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-3 d-none d-lg-block p-5 ps-lg-0">
                    <h3 class="position-relative mb-5 arrow-bottom">رهن و اجاره سایر شهرها</h3>
                    <ul class="list-unstyled">
                        <li v-for="item in tehranLinks" class="mb-4">
                            <a href="#" class="text-muted">{{ item.title }}</a>
                        </li>
                    </ul>
                </div>
            </div> -->

      <div
        class="row mt-5 ms-lg-3 p-5 ps-lg-5 justify-content-between align-items-start"
      >
        <div class="col-12 col-lg-4">
          <img src="../assets/images/header/logo.jpg" width="150px" alt="" />
          <p class="text-muted">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و...
          </p>
          <router-link to="/aboutus" class="fw-bold text-muted"
            >اطلاعات بیشتر...</router-link
          >
        </div>
        <div class="col-6 col-lg-2 mt-5 mt-lg-0">
          <h4 class="mb-4 fw-bold">شهر ها</h4>
          <p class="mb-4"><a href="#" class="text-muted">تهران</a></p>
          <p class="mb-4"><a href="#" class="text-muted">مشهد</a></p>
          <p><a href="#" class="text-muted">مازندران</a></p>
        </div>
        <div class="col-6 col-lg-2 mt-5 mt-lg-0">
          <h4 class="mb-4 fw-bold">دسترسی سریع</h4>
          <p class="mb-4"><a href="#" class="text-muted">خرید و فروش</a></p>
          <p class="mb-4"><a href="#" class="text-muted">رهن و اجاره</a></p>
          <p class="mb-4"><a href="#" class="text-muted">مشاورین املاک</a></p>
          <p>
            <router-link to="/aboutus" class="text-muted"
              >تماس با ما</router-link
            >
          </p>
        </div>
        <div class="col-12 col-lg-3 mt-5 mt-lg-0">
          <div class="row">
            <h4 class="col-6 col-lg-12 fw-bold">مارادنبال کنید</h4>
            <p class="mt-lg-4 col-6 col-lg-12">
              <span class="me-2">
                <i class="fab fa-linkedin fa-2x"></i>
              </span>
              <span class="me-2">
                <i class="fab fa-twitter fa-2x"></i>
              </span>
              <span class="me-2">
                <i class="fab fa-instagram fa-2x"></i>
              </span>
              <span>
                <i class="fab fa-facebook fa-2x"></i>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid m-0 p-0">
      <div
        class="row justify-content-between align-items-center height__full color-bg-green w-100 m-0 p-0"
      >
        <div class="col-12 col-lg-6">
          <p class="text-light text-center mt-3">طراحی توسط AmlakPlus</p>
        </div>
        <!-- <div class="col-12 col-lg-6">
                    <p class="text-light text-center mt-3">@2022, AmlaKPlus.ir.All rights reserved</p>
                </div> -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      tehranLinks: [
        {
          title: "خرید آپارتمان در تهران(36081)",
          url: "",
        },
        {
          title: "خرید آپارتمان در پونک(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در نیاوران(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در فرمانیه(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در زعفرانیه(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در پونک(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در قیطریه(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در پاسداران(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در پونک(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در جردن(1302)",
          url: "",
        },
        {
          title: "خرید آپارتمان در شهرک غرب(1302)",
          url: "",
        },
      ],
    };
  },
};
</script>